import React from 'react';
import { Shield, HeartBroken, Lock, HeartShine } from '@solar-icons/react';
import { useTranslation } from 'react-i18next';

const LegacyVaultValueProposition: React.FC = () => {
    const { t } = useTranslation();
    const valueProps = [
        {
            icon: <Shield size={32} color="#2a6355" />,
            title: t('lv_page.value.no_lost_assets'),
            description: t('lv_page.value.the_average_family'),
        },
        {
            icon: <HeartBroken size={32} color="#f38173" />,
            title: t('lv_page.value.less_family_stress'),
            description: t('lv_page.value.spare_them_300'),
        },
        {
            icon: <Lock size={32} color="#2a6355" />,
            title: t('lv_page.value.digital_physical_security'),
            description: t('lv_page.value.bank_level_encryption'),
        },
        {
            icon: <HeartShine size={32} color="#f38173" />,
            title: t('lv_page.value.your_voice_preserved'),
            description: t('lv_page.value.leave_more_than_documents'),
        },
    ];

    return (
        <section className="overflow-x-hidden py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] px-4">
                <div className="mx-auto pb-14 text-center lg:w-2/3 lg:pb-24">
                    <h2 className="mb-5 text-[26px]/7 font-bold text-green-700 dark:text-white">{t('lv_page.value.why_choose_legacy_vault')}</h2>
                    <p className="text-lg md:text-xl">{t('lv_page.value.protect_what_matters')}</p>
                </div>

                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
                    {valueProps.map((prop, index) => (
                        <div
                            key={index}
                            className="group relative rounded-xl border border-green-200 bg-white p-8 text-center transition-all duration-300 hover:border-green-300 hover:shadow-lg dark:border-green-800 dark:bg-dark dark:hover:border-green-700"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay={index * 100}
                        >
                            <div className="mb-6 flex justify-center">{prop.icon}</div>
                            <h3 className="mb-4 text-xl font-bold text-green-700 dark:text-white">{prop.title}</h3>
                            <p className="text-gray-600 dark:text-gray-300">{prop.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultValueProposition;
